<template>
    <headerSearch></headerSearch>
    <div class="w1440 personal_center">
        <div class="flex-box col90 ptb10 page_location">
            当前位置：<router-link class="col04" to="/BaseInfo">用户中心<span class="plr5">/</span></router-link>
            <div class="now_page">发票管理</div>
        </div>
        <div class="flex-box flex-col-start">
            <personal-nav :firstIndex="3" :secondIndex="-1"></personal-nav>
            <div class="ml10 flex-grow-1 part_r">
                <div class="flex-box flex-between mb35">
                    <div class="col90 fs18">可开票订单：<span class="fwb"
                            :class="orderList.length > 0 ? 'col12' : 'col90'">{{ orderList.length
                            }}</span> 个</div>
                    <div class="intro fs16 col90 flex-box cursor" @click="invoicePop">开票说明</div>
                </div>

                <div class="flex-box mb45">
                    <div class="input_box flex-box">
                        <input type="text" class="flex-grow-1 fs14" placeholder="搜索我的订单" v-model="q">
                        <div class="cursor search_btn fs14" @click="search">搜索</div>
                    </div>
                    <!-- <router-link class="flex-box fs16 go_open col12 cursor" to="Title">我的发票抬头</router-link> -->
                </div>
                <div v-if="orderList.length > 0">
                    <div class="flex-box">
                        <div class="flex-grow-1 fs16 col12">已选中 <span class="fwb">{{ calcuNum() }}</span> 个订单，共计：<span
                                class="fwb">¥
                                {{ calcuPrice() }}</span></div>
                        <div class="btn fs14 cursor" @click="toApply">去开票</div>
                    </div>
                    <div class="title_box flex-box fs14 col04 tc">
                        <div class="check" :class="isAll ? 'active' : ''" @click="chooseAll"></div>
                        <div class="box1">购买时间</div>
                        <div class="box2">商品名称</div>
                        <div class="box3">订单编号</div>
                        <div class="flex-grow-1">金额</div>
                    </div>
                    <div class="invoice_item flex-box fs14 col04" v-for="(item, index) in orderList" :key="index">
                        <div class="check" :class="item.isChoose ? 'active' : ''" @click="chooseOne(index)">
                        </div>
                        <div class="box1 tc">{{ item.createtime_text }}</div>
                        <div class="box2 m-ellipsis-l2">
                            <template v-for="goods in item.items">
                                <template v-if="item.activity_tag">【{{ item.activity_tag }}】</template>{{
                                    goods.goods_title }}
                            </template>
                        </div>
                        <div class="box3 tc col90">{{ item.order_sn }}</div>
                        <div class="flex-grow-1 tc coleb fwb">¥ {{ item.invoice_fee }}</div>
                    </div>

                </div>

                <div v-if="orderList.length == 0" class="nodata fs16 tc">
                    <img src="../../../assets/static/icon/c_notitle.png" class="c_nodata" alt="">
                    <div>暂无相关数据</div>
                </div>
                <pagination :sumCount="sumCount" :perCount="perCount" @pageTurn="pageTurn" v-show="sumCount > perCount">
                </pagination>
            </div>
        </div>
    </div>
    <popup :visible="popShow" @close="popShow = false">
        <div class="intro_pop">
            <img src="../../../assets/static/icon/c_pop_close.png" class="c_pop_close" @click="popShow = false" alt="">
            <div class="article">
                <div class="fs22 col04 title tc mb35">开票说明</div>
                <div class="detail fs16 col90">
                    <div v-html="article.content"></div>
                </div>
            </div>
        </div>
    </popup>
</template>

<script>
import moment from "moment";
import PersonalNav from "../../../components/PersonalNav.vue";
import { useHead } from '@unhead/vue'
import { onMounted } from "vue"
export default {
    setup() {
        onMounted(() => {
            useHead({
                title: "发票管理-小狮优选",
                meta: [
                    { name: "description", content: "This is my page description" },
                    { property: "og:title", content: "My Page Title" },
                    { property: "og:description", content: "This is my page description" },
                    { property: "og:url", content: "https://example.com/my-page" },
                    { property: "og:image", content: "https://example.com/my-image.jpg" },
                ],
                link: [{ rel: "canonical", href: "https://example.com/my-page" }],
            })
        })
    },
    components: {
        PersonalNav,
    },
    data() {
        return {
            orderList: [],
            popShow: false,
            q: '',
            page: 1,
            sumCount: 0,
            perCount: 10,
            isAll: false,

            article: {},
            totalPrice: 0
        };
    },
    created() {
        this.getList();
    },
    methods: {
        //格式化日期
        formatDate(timestamp) {
            return moment(timestamp).format('YYYY-MM-DD HH:mm:ss');
        },
        search() {
            this.page = 1;
            this.getList();
        },
        // 获取发票订单列表
        getList() {
            this.$api.getInvoiceOrder({
                q: this.q,
                page: this.page
            }).then(res => {
                this.orderList = res.data.data;
                this.orderList.map(item => ({
                    ...item,
                    isChoose: false,
                }))
                this.sumCount = res.data.total;
                this.perCount = res.data.per_page;
            }).catch(err => {
                console.log(err)
            })
        },
        // 分页
        pageTurn(e) {
            this.page = e + 1;
            this.getList();
        },
        invoicePop() {
            let config = this.$root.$data.config;
            this.$api.getAgreement({ id: config.app.invoice_agreement }).then(ret => {
                this.article = ret.data;
                this.popShow = !this.popShow;
            })

        },
        //全选
        chooseAll() {
            this.isAll = !this.isAll;
            this.orderList.map(item => {
                if (this.isAll) {
                    item.isChoose = true;
                } else {
                    item.isChoose = false;
                }
            })
        },
        chooseOne(index) {
            this.orderList[index].isChoose = !this.orderList[index].isChoose;
            let count = 0;
            this.orderList.map(item => {
                if (item.isChoose) {
                    count++;
                }
            })
            this.isAll = count == this.orderList.length ? true : false;
        },
        //选择数量
        calcuNum() {
            let total = 0;
            this.orderList.forEach(item => {
                if (item.isChoose) {
                    total += 1;
                }

            })
            return total;
        },
        //开票金额
        calcuPrice() {
            let totalPrice = 0;
            this.orderList.forEach(item => {
                if (item.isChoose) {
                    totalPrice += item.invoice_fee;
                }

            })
            return totalPrice.toFixed(1);
        },
        // 去开票
        toApply() {
            let ids = [];
            this.orderList.map(item => {
                if (item.isChoose) {
                    ids.push(item.id);
                }
            })
            if (ids.length == 0) {
                this.$message({
customClass: 'custom-message',
                    message: '请选择订单',
                    type: 'error',
                    duration: 3000
                })
                return;
            }
            let id = ids.join(',');
            this.$router.push({ path: '/InvoiceApply', query: { ids: id } });
        }
    },
};
</script>

<style lang="less" scoped>
.part_r {
    padding: 41px 44px 100px;
    background: #fff;

    .intro::before {
        display: block;
        content: "";
        width: 18px;
        height: 18px;
        background: url('/src/assets/static/icon/c_intro.png') no-repeat center;
        background-size: 100%;
        margin-right: 8px;
    }

    .input_box {
        width: 468px;
        height: 40px;
        border-radius: 8px;
        border: 2px solid #3d7efe;
        padding-left: 20px;

        &::before {
            content: "";
            display: block;
            background: url("/src/assets/static/icon/c_search.png") no-repeat center;
            background-size: 100%;
            width: 22px;
            height: 22px;
            margin-right: 10px;
        }

        input {
            height: 52px;
        }

        .search_btn {
            width: 80px;
            height: 40px;
            border-radius: 8px;
            background: #1275ff;
            text-align: center;
            line-height: 40px;
            margin: -1px -1px 0 0;
            color: #ffffff;
            font-weight: 400;
            letter-spacing: 4.090909px;
        }
    }

    .go_open {
        margin-left: 104px;
    }

    .title_box {
        height: 50px;
        background: #fafcff;
        margin-top: 42px;
    }

    .invoice_item {
        height: 68px;
        border-bottom: 1px solid #c0cfdd;
    }

    .check {
        width: 20px;
        height: 20px;
        background: url('/src/assets/static/icon/c_check.png') no-repeat center;
        background-size: 100%;
        margin: 0 38px 0 44px;
        cursor: pointer;

        &.active {
            background-image: url('/src/assets/static/icon/c_check-on.png');
        }
    }

    .btn {
        width: 108px;
        height: 42px;
        border-radius: 6px;
        background: #1275ff;
        line-height: 42px;
        text-align: center;
        color: #fff;
        letter-spacing: 1.6px;
    }

    .box1 {
        width: 200px;
    }

    .box2 {
        width: 300px;
        padding: 0 40px;
    }

    .box3 {
        width: 260px;
    }

}</style>
